/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @emails oncall+relay
 * 
 * @format
 */
'use strict';

var React = require('react');

var prepareEntryPoint = require('./prepareEntryPoint');

var useRelayEnvironment = require('./useRelayEnvironment');

var _require = require('react'),
    useMemo = _require.useMemo;

var _require2 = require('relay-runtime'),
    stableCopy = _require2.stableCopy;

function stableStringify(value) {
  var _JSON$stringify;

  return (_JSON$stringify = JSON.stringify(stableCopy(value))) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : 'null';
}

function LazyLoadEntryPointContainer(_ref) {
  var entryPoint = _ref.entryPoint,
      entryPointParams = _ref.entryPointParams,
      props = _ref.props,
      environmentProvider = _ref.environmentProvider;
  var environment = useRelayEnvironment();
  var getPreloadProps = entryPoint.getPreloadProps; // IMPORTANT: Loading the component may suspend (throw), so the props
  // *must* be computed first to fetch the component's data-dependencies in
  // parallel with the component itself (the code).

  var entryPointParamsHash = stableStringify(entryPointParams);

  var _useMemo = useMemo(function () {
    var _environmentProvider;

    return prepareEntryPoint((_environmentProvider = environmentProvider) !== null && _environmentProvider !== void 0 ? _environmentProvider : {
      getEnvironment: function getEnvironment() {
        return environment;
      }
    }, entryPoint, entryPointParams); // NOTE: stableParams encodes the information from params
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [environment, environmentProvider, getPreloadProps, entryPointParamsHash]),
      getComponent = _useMemo.getComponent,
      queries = _useMemo.queries,
      entryPoints = _useMemo.entryPoints,
      extraProps = _useMemo.extraProps;

  var Component = useMemo(function () {
    return getComponent();
  }, [getComponent]);
  return React.createElement(Component, {
    entryPoints: entryPoints,
    extraProps: extraProps,
    props: props,
    queries: queries
  });
}

module.exports = LazyLoadEntryPointContainer;